export const LOAD_DISTRIBUTOR = 1;
export const TRANSFER = 2;
export const DEVOLUTION = 3;
export const ADJUST = 4;

export const CODE_MASK_REGEX = /^([0-9]{4}-[0-9]{8})+$/;

export const TYPE_ORDER = 'Pedido';
export const TYPE_DELIVERY_NOTE = 'Remito';

export const MAIN_DEPOSIT_LABEL = 'Casa Central';

export const TRASHED = 'trashed';
